"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeTranslations = exports.T = exports.t_cond = exports.t = exports.getCurrentLocale = exports.setCurrentLocale = exports.getPreferredLocale = exports.I18nProvider = void 0;
const react_intl_1 = require("react-intl");
const cache = (0, react_intl_1.createIntlCache)();
let currentLocale;
exports.I18nProvider = react_intl_1.IntlProvider;
function getPreferredLocale(availableLocales) {
  if (!availableLocales) {
    throw new Error('Failed to get preferred locale: Missing locale list');
  }
  const navigator = window.navigator;
  const navigatorLocale = navigator.languages && navigator.languages[0] || navigator.language;
  let locale = navigatorLocale.slice(0, 2);
  if (!availableLocales.includes(locale)) {
    return null;
  }
  return locale;
}
exports.getPreferredLocale = getPreferredLocale;
function setCurrentLocale(localeName, messages) {
  const locale = {
    en: 'en-EN',
    es: 'es-ES',
    fr: 'fr-FR',
    ko: 'ko-KR',
    zh: 'zh-CN',
    ja: 'ja-JP'
  }[localeName];
  currentLocale = (0, react_intl_1.createIntl)({
    locale,
    messages
  }, cache);
}
exports.setCurrentLocale = setCurrentLocale;
function getCurrentLocale() {
  return currentLocale;
}
exports.getCurrentLocale = getCurrentLocale;
function t(id, values) {
  return currentLocale.formatMessage({
    id
  }, values);
}
exports.t = t;
function t_cond(id, defaultId, values) {
  if (!id) {
    return currentLocale.formatMessage({
      id: defaultId
    }, values);
  }
  const message = currentLocale.formatMessage({
    id
  }, values);
  if (message === id || !message) {
    return currentLocale.formatMessage({
      id: defaultId
    }, values);
  }
  return message;
}
exports.t_cond = t_cond;
exports.T = react_intl_1.FormattedMessage;
function mergeTranslations() {
  let target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }
  return [target, ...sources].reduce((result, obj) => _mergeTranslations(result, obj), {});
}
exports.mergeTranslations = mergeTranslations;
function _mergeTranslations() {
  let target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const merged = Object.keys(source).reduce((result, key) => {
    // @ts-ignore
    result[key] = typeof source[key] === 'object' ? _mergeTranslations(target[key], source[key]) : source[key];
    return result;
  }, target);
  return merged;
}